
import { Spin } from "antd";
const Loading = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <Spin size="large" tip="Loading..." />
  </div>
);

export default Loading;



















// import { Spin } from "antd";
// import { LoadingOutlined } from "@ant-design/icons";

// const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

// const Loading = ({ text = "Loading..." }) => {
//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         height: "100vh",
//         background: "#f0f2f5",
//       }}
//     >
//       <Spin indicator={antIcon} />
//       <p style={{ marginTop: 10, fontSize: 16, color: "#555" }}>{text}</p>
//     </div>
//   );
// };

// export default Loading;